import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";

import {
  Navigate
} from "react-router-dom";

import {
  API_URL
} from "../config/api";

function AdminRoute({ children }) {

  const [status, setStatus] =
    useState("checking");

  useEffect(() => {

    let cancelled = false;

    const verifySession = async () => {

      const token =
        localStorage.getItem(
          "adminToken"
        );

      if (!token) {

        localStorage.removeItem(
          "isAdmin"
        );

        if (!cancelled) {
          setStatus(
            "unauthenticated"
          );
        }

        return;
      }

      try {

        await axios.get(
          `${API_URL}/api/admin/me`
        );

        if (!cancelled) {

          /*
           * This flag is retained only to prevent
           * admin article views being counted.
           * It does not grant access to /admin.
           */
          localStorage.setItem(
            "isAdmin",
            "true"
          );

          setStatus(
            "authenticated"
          );

        }

      } catch {

        localStorage.removeItem(
          "adminToken"
        );

        localStorage.removeItem(
          "isAdmin"
        );

        if (!cancelled) {
          setStatus(
            "unauthenticated"
          );
        }

      }

    };

    verifySession();

    return () => {
      cancelled = true;
    };

  }, []);

  if (status === "checking") {
    return (
      <main
        className="homepage"
        style={{
          textAlign: "center",
          paddingTop: "60px"
        }}
      >
        <p>
          Verifying admin session...
        </p>
      </main>
    );
  }

  if (
    status !== "authenticated"
  ) {
    return (
      <Navigate
        to="/login"
        replace
      />
    );
  }

  return children;

}

export default AdminRoute;